import axios from "axios";
import { CONFIG } from "../../config";

// The original lesson quizzes are keyed by the lesson's video ID in Course Management.
export const getLegacyLessonQuiz = async (lessonId) => {
	try {
		const response = await axios.get(`${CONFIG.COURSEURL}/api/quiz/${lessonId}`);
		return response.data;
	} catch (error) {
		console.error("Error fetching legacy lesson quiz:", error);
		return null;
	}
};
